export const scissorStates = { "SCRAP": "Scrap", "PRODUCTION": "Production", "UNPLANNEDSTOP": "Unplanned Stop", "PLANNEDSTOP": "Planned Stop"}
export const scissorTypes = {"UPPER": "UPPER", "LOWER": "LOWER"}